"use strict";
/**
 * Background Job Types
 *
 * Interfaces for background job system.
 * Used by frontend (polling) and backend (job execution).
 */
Object.defineProperty(exports, "__esModule", { value: true });
